import React from 'react'
import { connect } from 'react-redux'
import FontAwesome from 'react-fontawesome'

import Config from 'Config'
import SimpleModal from 'components/Elements/SimpleModal'
import FeedbackActions from 'actions/feedback'
import { pluralize } from 'utils/strings'
import { shortDayTime } from 'utils/dates'

import 'stylesheets/feedback-creator.scss'

const FormButtons = ({ children }) => {
  return (
    <div className="clearfix form-buttons">
      <div className="pull-right">{ children }</div>
    </div>
  )
}

const FeedbackTypes = {
  SERVICE: 'service_issue',
  WIPPERSNAPPER: 'wippersnapper_question',
  WIPPER_SUGGESTION: 'wippersnapper_suggestion',
  PLUS: 'plus_question',
  BETA: 'beta_request',
  SUGGESTION: 'suggestion',
  PROJECT: 'project_help',
  GENERAL: 'general_question',
  OTHER: 'other'
}

class _FeedbackModal extends React.Component {
  close = () => {
    this.props.dispatch(FeedbackActions.toggleModal(false, this.props.identifier))
  }

  select = () => {
    this.props.dispatch(FeedbackActions.load())
  }

  render() {
    return (
      <SimpleModal id='aio-feedback-modal' title="Adafruit IO Feedback" show={this.props.show} onHide={this.close} onEntered={this.select}>
        { this.props.children }
      </SimpleModal>
    )
  }
}

const FeedbackModal = connect((state, ownProps) => {
  if (state.feedback.showModal.identifier === ownProps.identifier) {
    return {
      show: state.feedback.showModal.show
    }
  } else {
    return {
      show: false
    }
  }
})(_FeedbackModal)

const RadioButton = ({ onChange, value, selected }) => {
  return (
    <input type='radio' name='feedback_type' value={value} checked={selected === value} onChange={onChange} />
  )
}

class _PickFeedbackType extends React.Component {
  constructor(...args) {
    super(...args)

    this.state = {
      selected: null,
      showPrevious: false
    }
  }

  select = (evt) => {
    this.setState({ selected: evt.target.value })
  }

  submit = (evt) => {
    evt.preventDefault()

    if (!this.state.selected) {
      // no selection
      return
    }

    switch (this.state.selected) {
      case FeedbackTypes.SERVICE:
      case FeedbackTypes.WIPPERSNAPPER:
      case FeedbackTypes.WIPPER_SUGGESTION:
      case FeedbackTypes.PLUS:
      case FeedbackTypes.SUGGESTION:
      case FeedbackTypes.OTHER:
      case FeedbackTypes.BETA:
        this.props.dispatch(FeedbackActions.toStep('feedback', this.state.selected))
        break
      case FeedbackTypes.PROJECT:
      case FeedbackTypes.GENERAL:
      default:
        this.props.dispatch(FeedbackActions.toStep('forum', this.state.selected))
        break
    }
  }

  feedbackTableRows() {
    return this.props.feedbacks.map(fb => {
      return (
        <tr key={fb.id}>
          <td>{shortDayTime(fb.created_at, {seconds: true})}</td>
          <td>{fb.subject}</td>
        </tr>
      )
    })
  }

  feedbackTable() {
    if (this.state.showPrevious) {
      return (
        <table className='table compact'>
          <thead>
            <tr>
              <th>Created</th>
              <th>Subject</th>
            </tr>
          </thead>
          <tbody>
            { this.feedbackTableRows() }
          </tbody>
        </table>
      )
    } else {
      return (
        <p>
          <a onClick={() => this.setState({ showPrevious: true })}>Show previous feedback</a>
        </p>
      )
    }
   }

  feedbacks() {
    if (this.props.feedbacks && this.props.feedbacks.length > 0) {
      const len = this.props.feedbacks.length
      return (
        <div className='previous-requests'>
          <p>You have sent {pluralize(len, 'request')}.</p>

          { this.feedbackTable() }
        </div>
      )
    }
  }

  render() {
    const buttonDisabled = !this.state.selected

    return (
      <div>
        <form onSubmit={this.submit}>
          <p>
            If you have noticed a bug with Adafruit IO, have a question about
            IO+, or have any other reason you want to get in touch with the
            Adafruit IO team then you have come to the right place. Fill out
            the form below to figure out the best way to reach us.
          </p>

          <p>How can we help you?</p>

          <ul className='options'>
            <li>
              <label>
                <RadioButton value={FeedbackTypes.SERVICE} onChange={this.select} {...this.state} />
                There is an issue with Adafruit IO. Something is broken!
              </label>
            </li>
            <li>
              <label>
                <RadioButton value={FeedbackTypes.WIPPERSNAPPER} onChange={this.select} {...this.state} />
                There is an issue with WipperSnapper. Something is broken!
              </label>
            </li>
            <li>
              <label>
                <RadioButton value={FeedbackTypes.WIPPER_SUGGESTION} onChange={this.select} {...this.state} />
                I have feedback or suggestions for the WipperSnapper Beta
              </label>
            </li>
            <li>
              <label>
                <RadioButton value={FeedbackTypes.PLUS} onChange={this.select} {...this.state} />
                I have a question about Adafruit IO+ or Adafruit IO payments
              </label>
            </li>
            <li>
              <label>
                <RadioButton value={FeedbackTypes.GENERAL} onChange={this.select} {...this.state} />
                I have a general question about Adafruit IO
              </label>
            </li>
            <li>
              <label>
                <RadioButton value={FeedbackTypes.SUGGESTION} onChange={this.select} {...this.state} />
                I have a suggestion for Adafruit IO
              </label>
            </li>
            <li>
              <label>
                <RadioButton value={FeedbackTypes.PROJECT} onChange={this.select} {...this.state} />
                I need help with my project hardware or code
              </label>
            </li>
            <li>
              <label>
                <RadioButton value={FeedbackTypes.OTHER} onChange={this.select} {...this.state} />
                It's something not listed here
              </label>
            </li>
          </ul>

          <FormButtons>
            <button className='btn blue' disabled={buttonDisabled}>CONTINUE</button>
          </FormButtons>

        </form>

        { this.feedbacks() }
      </div>
    )
  }
}

const PickFeedbackType = connect((state) => {
  return {
    feedbacks: state.feedback.feedbacks
  }
})(_PickFeedbackType)

class _ForumLink extends React.Component {
  close = () => {
    this.props.dispatch(FeedbackActions.toggleModal(false, this.props.identifier))
  }

  goBack = () => {
    this.props.dispatch(FeedbackActions.toStep('pick_type'))
  }

  codeRequest() {
    if (this.props.subject === FeedbackTypes.PROJECT){
      return (
        <p>
          Due to the amount of help requests we receive, we are unfortunately
          unable to provide personal support on code or hardware project
          related questions.
        </p>
      )
    }
    return null
  }

  render() {
    return (
      <div>
        <p>
          It sounds like we could help you better on the Adafruit IO
          forums, <a href={Config.forumsUrl} target="_blank" rel="noopener">click here to go over there now</a>.
          You can also check
          out <a href='https://discord.gg/adafruit'>the Adafruit Discord chat server</a> which
          has a channel dedicated to Adafruit IO discussion.
        </p>

        <p>
          Community is a huge part of what makes Adafruit special.
          Through the forums and the conversations that happen there, you'll be
          able to get answers from a wider variety of people and share what you
          learn with the community.
        </p>

        { this.codeRequest() }

        <FormButtons>
          <button className='btn' onClick={this.goBack}>
            <FontAwesome name='chevron-left' /> GO BACK
          </button>
          <button className='btn blue' onClick={this.close}>CLOSE</button>
        </FormButtons>
      </div>
    )
  }
}
const ForumLink = connect((state) => {
  return {
    step: state.feedback.step,
    subject: state.feedback.subject
  }
})(_ForumLink)

class _FeedbackForm extends React.Component {
  constructor(...args) {
    super(...args)

    this.state = {
      form: {},
      error: null,
      errorMessage: null,
      enable: false,
    }

    this.inputs = new Map();
  }

  goBack = () => {
    this.props.dispatch(FeedbackActions.toStep('pick_type'))
  }

  submit = (evt) => {
    evt.preventDefault()

    if (!this.state.enable) {
      return
    }

    const form = {}

    Array.from(this.inputs.values())
         .filter(i => i !== null)
         .forEach(i => {
           if (i.multiple) {
             let vals = []
             for (let n = 0; n < i.options.length; n++) {
               if (i.options.item(n).selected) {
                 vals.push(i.options.item(n).value)
               }
             }
             form[i.name] = vals.join(',')
           } else if (i.type === 'checkbox' && i.checked) {
             form[i.name] = i.value
           } else {
             form[i.name] = i.value
           }
         });

    this.props.dispatch(FeedbackActions.create(form)).then(() => {
      this.props.dispatch(FeedbackActions.toStep('thanks', this.props.subject))
    }).catch(ex => {
      this.setState({
        error: ex,
        errorMessage: "There was a problem saving this message. Please try again or get in touch with us on the forums."
      })
    })
  }

  register = (input) => {
    if (!input) return;
    this.inputs.set(input.name, input)
  }

  subject() {
    switch (this.props.subject) {
      case FeedbackTypes.SERVICE:
        return 'There is an issue with Adafruit IO. Something is broken!'
      case FeedbackTypes.WIPPERSNAPPER:
        return 'There is an issue with WipperSnapper. Something is broken!'
      case FeedbackTypes.WIPPER_SUGGESTION:
        return 'I have feedback or suggestions for the WipperSnapper Beta'
      case FeedbackTypes.PLUS:
        return 'I have a question about Adafruit IO+'
      case FeedbackTypes.GENERAL:
        return 'I have a general question about Adafruit IO'
      case FeedbackTypes.SUGGESTION:
        return 'I have a suggestion for Adafruit IO'
      case FeedbackTypes.PROJECT:
        return 'I need help with my project hardware or code'
      case FeedbackTypes.OTHER:
        return ''
      case FeedbackTypes.BETA:
        return 'I would like to participate in a private beta'
      default:
        return 'I need help with Adafruit IO'
    }
  }

  description() {
    if (this.state.error) {
      return (
        <div className='error'>
          <p>{ this.state.errorMessage }</p>
        </div>
      )
    }

    switch (this.props.subject) {
      case FeedbackTypes.SERVICE:
        return (
          <div>
            <p>
              Oh no! It sounds like something might be broken. Please try to be
              specific about the problem you're seeing including links to the
              page you're having trouble on and the code you're using, if that
              applies.
            </p>

            <p>
              After leaving a note here, it would also be good to <a href={Config.forumsUrl} target="_blank" rel="noopener">search the forums</a> to
              see if anyone else has run into the same problem recently.
            </p>
          </div>
        )
      case FeedbackTypes.WIPPERSNAPPER:
        return (
          <div>
            <p>
              Oh no! It sounds like something might be broken with WipperSnapper.
              Thank you for your patience and willingness to help as we get
              through the Beta process! Please try to be specific about the
              problem you're seeing including links to the page you're having
              trouble on and the code you're using, if that applies.
            </p>

            <p>
              After leaving a note here, it would also be good to <a href={ Config.wipperForumsUrl } target="_blank" rel="noopener">search the WipperSnapper forums</a> to
              see if anyone else has run into the same problem recently.
            </p>
          </div>
        )
      case FeedbackTypes.WIPPER_SUGGESTION:
        return (
          <div>
            <p>
              Cool! We love new ideas and are glad to have a supportive community.
            </p>

            <p>
              We can't wait to see what you have in mind! Please be aware that
              while we read and consider every message, we aren't able to
              respond directly to every feature request.
            </p>
          </div>
        )
      case FeedbackTypes.PLUS:
        return (
          <div>
            <p>
              Adafruit IO+ is our paid, higher access level plan. We're happy
              to answer any questions you have about it or help if you're
              having problems with accessing IO+.
            </p>
            <p>
              Please do not include any personal information or account details
              in your feedback.
            </p>
          </div>
        )
      case FeedbackTypes.OTHER:
      case FeedbackTypes.GENERAL:
        return (
          <div>
            <p>
              For general questions about Adafruit IO, our IO-friendly open
              source code libraries, or Adafruit hardware, we would prefer to
              answer your questions <a href={Config.forumsUrl} target="_blank" rel="noopener">on the forums</a> so
              that the whole community can benefit.
            </p>

            <p>
              Due to the amount of support requests we receive, we are not able
              to respond directly to every message.
            </p>
          </div>
        )
      case FeedbackTypes.SUGGESTION:
        return (
          <div>
            <p>
              Cool! We love new ideas and are glad to have a supportive community.
            </p>

            <p>
              Please be aware that we're careful about what features we can add
              and how we make changes, and while we appreciate your input, we
              aren't able to respond directly to every feature request.
            </p>
          </div>
        )
      default:
        // should not end up here
    }
  }

  backButton() {
    // default type means forced feedback form process
    if (!this.props.selectedType) {
      return (
        <button className='btn' onClick={this.goBack}>
          <FontAwesome name='chevron-left' /> GO BACK
        </button>
      )
    }
  }

  subjectSection() {
    const hideInput = (this.props.subject !== FeedbackTypes.OTHER),
          inputType = hideInput ? 'hidden' : 'text'

    return (
      <div className="form-group">
        <label htmlFor='subject'>Subject</label>
        <input className='form-control'
               name='subject'
               type={inputType}
               ref={this.register}
               defaultValue={this.subject()} />
        { hideInput && <p>{ this.subject() }</p> }
      </div>
    )
  }

  render() {
    return (
      <form className='form feedback-form' onSubmit={this.submit}>

        { this.description() }
        { this.subjectSection() }

        <div className="form-group">
          <label htmlFor='message'>Message</label>
          <textarea className='form-control' name='message' ref={this.register} onChange={() => this.setState({ enable: true })}></textarea>
        </div>

        <div className="checkbox">
          <label>
            <input type='checkbox' name='contact_request' ref={this.register} value='1' />
            It is okay to contact me at my Adafruit account email
          </label>
        </div>

        <FormButtons>
          { this.backButton() }
          <button className='btn blue' disabled={!this.state.enable}>SUBMIT</button>
        </FormButtons>
      </form>
    )
  }
}

const mapFeedbackFormStateToProps = (state, ownProps) => {
  if (ownProps.selectedType) {
    return {
      step: state.feedback.step,
      subject: ownProps.selectedType
    }
  }
  return {
    step: state.feedback.step,
    subject: state.feedback.subject
  }
}

const FeedbackForm = connect(mapFeedbackFormStateToProps)(_FeedbackForm)

class _FeedbackThanks extends React.Component {
  close = () => {
    this.props.dispatch(FeedbackActions.toggleModal(false, this.props.identifier))
  }

  description() {
    switch (this.props.subject) {
      case FeedbackTypes.SERVICE:
        return (
          <div>
            <p>
              Thank you for your report! We read and investigate every issue
              and error report we receive, but please understand that we may
              not be able to respond to every report directly.
            </p>

            <p>
              Be sure to also check out <a href={Config.forumsUrl}>the forums</a> and
              the <a href={Config.blogUrl}>Adafruit IO blog</a> to
              keep up to date with news and updates from Adafruit IO.
            </p>
          </div>
        )
      case FeedbackTypes.WIPPERSNAPPER:
        return (
          <div>
            <p>
              Thank you for your report! We're paying close attention to these
              with WipperSnapper in its Beta period, but please understand that
              we may not be able to respond to every report directly.
            </p>

            <p>
              Be sure to also check out <a href={Config.wipperForumsUrl}>the
              WipperSnapper-specific forums</a>, <a href={Config.forumsUrl}>the
              general IO forums</a>, and the <a href={Config.blogUrl}>Adafruit
              IO blog</a> to keep up to date with news and updates from Adafruit
              IO.
            </p>
          </div>
        )
      case FeedbackTypes.WIPPER_SUGGESTION:
        return (
          <p>
            Thank you for interest in the WipperSnapper Beta, and for sharing your idea with us!
          </p>
        )
      case FeedbackTypes.PLUS:
        return (
          <div>
            <p>
              Thank you for your interest in Adafruit IO+. We will do our best
              to address your issue or question in 2-3 business days.
            </p>
          </div>
        )
      case FeedbackTypes.GENERAL:
        return (
          <div>
            <p>
              We appreciate your feedback. We will do our best to address your
              issue but we may not be able to respond personally to every
              question or request.
            </p>

            <p>
              Make sure to check out <a href={Config.forumsUrl}>the forums</a> and
              the <a href={Config.blogUrl}>Adafruit IO blog</a> to
              keep up to date with news from Adafruit IO.
            </p>
          </div>
        )
      case FeedbackTypes.SUGGESTION:
        return (
          <p>
            Thank you for interest in Adafruit IO and for sharing your idea with us!
          </p>
        )
      case FeedbackTypes.OTHER:
      default:
        return (
          <p>
            We appreciate your feedback. We will do our best to address your
            issue but we may not be able to respond personally to every
            question or request.
          </p>
        )
        // should not end up here
    }
  }

  render() {
    return (
      <div>
        { this.description() }

        <p>
          <strong>Thanks for choosing Adafruit IO!</strong>
        </p>

        <FormButtons>
          <button className='btn blue' onClick={this.close}>Close</button>
        </FormButtons>
      </div>
    )
  }
}

const FeedbackThanks = connect((state) => {
  return {
    step: state.feedback.step,
    subject: state.feedback.subject
  }
})(_FeedbackThanks)

class _FeedbackSignIn extends React.Component {
  close = () => {
    this.props.dispatch(FeedbackActions.toggleModal(false, this.props.identifier))
  }

  render() {
    return (
      <div>
        <p>
          To make sure we're able to get in touch with you, we require that you
          have an active Adafruit IO account before you can submit feedback. Please
          use the "Sign In" button below to continue.
        </p>

        <p>
          <a className='btn blue large' href={Config.signInUrl}>Sign In</a>
        </p>

        <FormButtons>
          <button className='btn blue' onClick={this.close}>Close</button>
        </FormButtons>
      </div>
    )
  }
}

const FeedbackSignIn = connect((state) => {
  return {
    step: state.feedback.step,
    subject: state.feedback.subject
  }
})(_FeedbackSignIn)

class FeedbackCreator extends React.Component {
  view() {
    switch (this.props.step) {
      case 'pick_type':
        return <PickFeedbackType identifier={this.props.id} />
      case 'forum':
        return <ForumLink identifier={this.props.id} />
      case 'feedback':
        if (this.props.user) {
          return <FeedbackForm identifier={this.props.id} selectedType={this.props.selectedType} />
        } else {
          return <FeedbackSignIn identifier={this.props.id} />
        }
      case 'thanks':
        return <FeedbackThanks identifier={this.props.id} />
      default:
        return (
          <strong>NO STEP</strong>
        )
    }
  }

  render() {
    const content = this.view()

    return (
      <FeedbackModal title='Feedback? Need Help?' id='feedback-create-modal' identifier={this.props.id}>
        <div className='feedback-creator'>
          {content}
        </div>
      </FeedbackModal>
    )
  }
}

const mapState = (state, ownProps) => {
  const user = state.session ? state.session.user : null

  if (ownProps.selectedType) {
    if (state.feedback.step === 'feedback' || state.feedback.step === 'thanks') {
      return {
        user,
        step: state.feedback.step
      }
    } else {
      return {
        user,
        step: 'feedback'
      }
    }
  } else {
    return {
      user,
      step: state.feedback.step
    }
  }
}

export default connect(mapState)(FeedbackCreator)
